import { defineStore } from 'pinia'

export const useActivityStore = defineStore('activity', {
    state: () => ({
        activityData: null,
    }),

    actions: {
        // 更新整个表单
        updateActivity(activity) {
            this.activityData = activity
        },

        // 设置活动
        setActivity(activity) {
            this.activityData = activity
        },

        getActivity() {
            return this.activityData
        }
    },

    // 持久化（可选）：刷新页面数据不丢失
    persist: {
        enabled: true,
        strategies: [
            { storage: localStorage, paths: ['activityData'] }
        ]
    }
})